import { FormActions } from '../../../Form'
import { InhabitantFormInvitationActions } from '../InhabitantFormInvitationActions'

function InhabitantFormActions({
  isMobileActions,
  isSubmitting,
  onOpenInvitationModal,
  ...restProps
}) {
  return (
    <FormActions {...restProps} isSubmitting={isSubmitting}>
      {!isMobileActions ? (
        <InhabitantFormInvitationActions
          isSubmitting={isSubmitting}
          onOpenInvitationModal={onOpenInvitationModal}
        />
      ) : null}
    </FormActions>
  )
}

export default InhabitantFormActions
